import React, { useEffect } from 'react';
import Header from './Header';
import './Layout.css';
import Copyright from './Copyright';

function Layout({ children }) {
  useEffect(() => {
    const initLogo = () => {
      if (window.MSTLogo && document.getElementById('mst-logo-footer')) {
        window.MSTLogo.init('mst-logo-footer', { size: 36 });
      }
    };

    if (window.MSTLogo) {
      initLogo();
      return;
    }

    const existing = document.getElementById('mst-spinner-script');
    if (existing) {
      existing.addEventListener('load', initLogo);
      return;
    }

    const script = document.createElement('script');
    script.id = 'mst-spinner-script';
    script.src = '/mst-logo-spinner.js';
    script.onload = initLogo;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <div className="container">
          {children}
        </div>
      </main>
      <footer className="footer">
        <div className="container">
          <Copyright />
        </div>
        <div className="footer-developer">
          <div id="mst-logo-footer" />
        </div>
      </footer>
    </div>
  );
}

export default Layout;
